import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import underline from '../../assets/images/underline.svg';
import instant_loans from '../../assets/images/instant_loans/instant_loans.png';
import instant_cash from '../../assets/images/instant_loans/instant_cash.svg';
import low_interest_rate from '../../assets/images/instant_loans/low_interest_rate.svg';
import flexible_repayment from '../../assets/images/instant_loans/flexible_repayment.svg';
import payufinance_logo from '../../assets/images/instant_loans/lending_partners/payufinance.svg';
import moneyview_logo from '../../assets/images/instant_loans/lending_partners/moneyview.png';
import abcl_logo from '../../assets/images/instant_loans/lending_partners/ABCL_Logo.svg';
import incred_logo from '../../assets/images/instant_loans/lending_partners/incred_finance.svg';
import './InstantLoans.scss';

const InstantLoans = () => {
    return (
        <>
        <Header />
        <div id="instantloans" className="instantloans">
            <div>
                <div className='heading-wrap'>
                    <div className='heading-logo'>
                        <img src={instant_loans} alt="" width={460} />
                    </div>
                    <div className='heading-text short'>
                        <p><br /><span>Instant Loans<img src={underline + "#svgView(preserveAspectRatio(none))"} alt="" className='heading-text-underline' width="100%" /></span></p>
                        <div className='subtext'>As your trusted Loan Service Provider (LSP), Neocap delivers tailored financial solutions that empower restaurant partners to scale and expand their operations seamlessly</div>
                    </div>
                </div>

                <div className='heading-wrap-mobile'>
                    <div className='heading-text short'>
                        <p><span>Instant Loans<img src={underline + "#svgView(preserveAspectRatio(none))"} alt="" className='heading-text-underline' width="100%" /></span></p>
                    </div>
                    <div className='heading-logo'>
                        <img src={instant_loans} alt="" width="100%" />
                    </div>
                    <div className='subtext'>As your trusted Loan Service Provider (LSP), Neocap delivers tailored financial solutions that empower restaurant partners to scale and expand their operations seamlessly</div>
                </div>
            </div>
            <div className='content'>
                {/* Offerings */}
                <div className='details-grid'>
                    <div className='detail-item'>
                        <img className='detail-icon' src={instant_cash} alt="Instant Cash Access" />
                        <div className='detail-title'>Instant Cash Access</div>
                        <div className='detail-description'>Get quick access to funds for your delivery business with our fast approval process</div>
                    </div>
                    <div className='detail-item'>
                        <img className='detail-icon' src={low_interest_rate} alt="Low interest rates" />
                        <div className='detail-title'>Low Interest Rates</div>
                        <div className='detail-description'>Competitive interest rates designed specifically for delivery partners and small businesses</div>
                    </div>
                    <div className='detail-item'>
                        <img className='detail-icon' src={flexible_repayment} alt="Flexible Repayment" />
                        <div className='detail-title'>Flexible Repayment</div>
                        <div className='detail-description'>Choose repayment schedules that work with your cash flow and earning patterns</div>
                    </div>
                </div>

                {/* Loan Details */}
                <div className='details-grid'>
                    <div className='detail-item'>
                        <div className='detail-title'>Loan Amount</div>
                        <div className='detail-description'>Get up to 5 Cr</div>
                    </div>
                    <div className='detail-item'>
                        <div className='detail-title'>Interest Rate</div>
                        <div className='detail-description'>Starting from 0.79% p.m.</div>
                    </div>
                    <div className='detail-item'>
                        <div className='detail-title'>Approval Time</div>
                        <div className='detail-description'>Within 24 hours</div>
                    </div>
                </div>

                {/* Our partners */}
                <div className='grow-business-text heading-text short'>
                    <p>Our <span>Loan Partners<img src={underline + "#svgView(preserveAspectRatio(none))"} alt="" className='grow-business-text-underline' width="100%" /></span></p>
                    <div className='subtext'>Neocap or Swiggy does not provide any loan. Loan facility is provided by below partners</div>
                </div>
                <div className='lending-partners'>
                    <div>
                        <a href="https://payufin.in/" target="_blank" rel="noopener noreferrer">
                            <img src={payufinance_logo} alt="Payu Finance" />
                        </a>
                        <div>
                            <div>Ms. Caroline Dharmaraj</div>
                            <div><a href="mailto:grievance.smbswiggy@payufin.com">grievance.smbswiggy@payufin.com</a></div>
                            <div><a href="tel:02269821177">022-69821177</a><br />[Monday to Friday between 10 AM - 7 PM]</div>
                        </div>
                    </div>
                    <div>
                        <a href="https://moneyview.in/personal-loan" target="_blank" rel="noopener noreferrer">
                            <img src={moneyview_logo} alt="MoneyView" className='moneyview-logo' />
                        </a>
                        <div>
                            <div>Mr. Rishov Bhattacharjee</div>
                            <div><a href="mailto:grievance@moneyview.in">grievance@moneyview.in</a></div>
                            <div><a href="tel:+918069390476">+91 8069390476</a></div>
                        </div>
                    </div>
                    <div>
                        <a href="https://www.adityabirlacapital.com/" target="_blank" rel="noopener noreferrer">
                            <img src={abcl_logo} alt="ABCL" className='abcl-logo' />
                        </a>
                        <div>
                            <div>Mr. Arijit Sen</div>
                            <div><a href="mailto:grievance.finance@adityabirlacapital.com">grievance.finance@adityabirlacapital.com</a></div>
                            <div><a href="tel:+918045860196">+91 8045860196</a></div>
                        </div>
                    </div>
                    <div>
                        <a href="https://www.incred.com/" target="_blank" rel="noopener noreferrer">
                            <img src={incred_logo} alt="InCred Finance" className='incred-logo' />
                        </a>
                        <div>
                            <div>Mr. Vaidyanathan Ramamoorthy</div>
                            <div><a href="mailto:incred.grievance@incred.com">incred.grievance@incred.com</a></div>
                            <div><a href="tel:02242117777">022 - 4211 7777</a></div>
                        </div>
                    </div>
                </div>

                {/* Contact partners */}
                <div className='contact-details'>
                    <div className='detail-item'>
                        <div className='detail-title'>Neocap Nodal Officer Contact Details</div>
                        <div className='detail-description'>Mr. Amit Kumar</div>
                        <div className='detail-description'><a href="mailto:support.loans@swiggy.in">support.loans@swiggy.in</a></div>
                        <div className='detail-description'><a href="mailto:loansgrievanceredressal@swiggy.in">loansgrievanceredressal@swiggy.in</a></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};

export default InstantLoans;
